export enum Shifts {
    shiftA = 'shiftA',
    shiftB = 'shiftB',
    shiftC = 'shiftC',
    general = 'general',
}